type TooltipLine = string | false | null | undefined;

type BuildTooltipSeriesLineParams = {
  label: string;
  marker?: string;
  value: number | string;
};

export function buildTooltipSeriesLine({ label, marker, value }: BuildTooltipSeriesLineParams): string {
  return `${marker ?? ''}${label}: <strong>${value}</strong>`;
}

export function joinTooltipLines(lines: TooltipLine[]): string {
  return lines.filter(Boolean).join('<br/>');
}
